var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-finalizacao-associar-entregas',{attrs:{"finalizacoesServicos":_vm.obterFinalizacoesServicos(),"finalizacao":_vm.finalizacao},on:{"obterFinalizacaoAtualizada":function($event){return _vm.obterFinalizacaoAtualizada()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }